module.exports = __webpack_public_path__ + "static/media/advantage4.660b152f.png";